import { CameraIcon } from '../../Svg';
import { useState } from 'react';
import ARCapturePreview from './ARCapturePreview';
import { captureScene } from '@/util/screenshot';

type ARCaptureBtnProps = {
  videoId?: string;
  scenetType?: string;
};
const ARCaptureBtn = ({
  videoId = 'arjs-video',
  scenetType = 'AFRAME',
}: ARCaptureBtnProps) => {
  const [ss, setSS] = useState(undefined);
  const onCapture = async () => {
    const img = await captureScene(videoId, scenetType);
    if (img) setSS(img);
  };
  return (
    <>
      <div
        onClick={onCapture}
        className="absolute bottom-4 left-0 right-0 mx-auto w-fit cursor-pointer z-[10]"
      >
        <CameraIcon />
      </div>
      {ss && <ARCapturePreview img={ss} onClose={() => setSS(undefined)} />}
    </>
  );
};

export default ARCaptureBtn;
